<template>
  <div
    class="mt-5"
    v-if="activeProducts || inactiveProducts || bookableProducts"
  >
    <h2>Opplevelser</h2>
    <p>
      Her finner du dine aktive og inaktive opplevelser, samt
      bookingopplysninger.
    </p>
    <div class="section" v-if="activeProducts">
      <h4>Aktive produkter</h4>
      <b-table fixed :items="activeProducts" :fields="fields">
        <template #cell(name)="data">
          <a
            target="_blank"
            :href="`${urlPrefix}/opplevelser/${data.item.product.slug}`"
            >{{ data.item.product.name }} ({{ data.item.place.name }})</a
          >
        </template>
        <template #cell(show_details)="data">
          <b-button
            size="sm"
            @click="data.toggleDetails"
            class="mr-2"
            variant="outline-secondary"
          >
            {{ data.detailsShowing ? "Skjul" : "Vise" }} bookingopplysninger
          </b-button>
        </template>
        <template slot="row-details" slot-scope="data">
          <table class="table mt-3">
            <tbody>
              <tr v-if="data.item.price">
                <th>Pris</th>
                <td>
                  {{
                    parseInt(data.item.price.current.amount / 100).toFixed(2)
                  }}
                  kr
                </td>
              </tr>
              <tr v-if="data.item.booking_phone">
                <th>Telefonnummer</th>
                <td>{{ data.item.booking_phone }}</td>
              </tr>
              <tr v-if="data.item.booking_phone_time">
                <th>Telefontid</th>
                <td>{{ data.item.booking_phone_time }}</td>
              </tr>
              <tr v-if="data.item.booking_website_url">
                <th>Hjemmeside</th>
                <td>{{ data.item.booking_website_url }}</td>
              </tr>
              <tr v-if="data.item.booking_url">
                <th>Ekstern booking</th>
                <td>{{ data.item.booking_url }}</td>
              </tr>
              <tr v-if="data.item.booking_email">
                <th>E-postadresse</th>
                <td>{{ data.item.booking_email }}</td>
              </tr>
              <tr v-if="data.item.booking_address">
                <th>Adresse</th>
                <td>{{ data.item.booking_address }}</td>
              </tr>
              <tr v-if="data.item.booking_info">
                <th>Øvrig info</th>
                <td>
                  <div v-html="data.item.booking_info"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </b-table>
    </div>
    <div class="section" v-if="bookableProducts">
      <h4>Bookbare produkter</h4>
      <b-table fixed :items="bookableProducts" :fields="fields">
        <template #cell(name)="data">
          <a
            target="_blank"
            :href="`${urlPrefix}opplevelser/${data.item.product.slug}`"
            >{{ data.item.product.name }} ({{ data.item.place.name }})</a
          >
        </template>
        <template #cell(show_details)="data">
          <b-button
            size="sm"
            @click="data.toggleDetails"
            class="mr-2"
            variant="outline-secondary"
          >
            {{ data.detailsShowing ? "Skjul" : "Vise" }} bookingopplysninger
          </b-button>
        </template>
        <template slot="row-details" slot-scope="data">
          <table class="table mt-3">
            <tbody>
              <tr v-if="data.item.price">
                <th>Pris</th>
                <td>
                  {{
                    parseInt(data.item.price.current.amount / 100).toFixed(2)
                  }}
                  kr
                </td>
              </tr>
              <tr v-if="data.item.booking_phone">
                <th>Telefonnummer</th>
                <td>{{ data.item.booking_phone }}</td>
              </tr>
              <tr v-if="data.item.booking_phone_time">
                <th>Telefontid</th>
                <td>{{ data.item.booking_phone_time }}</td>
              </tr>
              <tr v-if="data.item.booking_website_url">
                <th>Hjemmeside</th>
                <td>{{ data.item.booking_website_url }}</td>
              </tr>
              <tr v-if="data.item.booking_url">
                <th>Ekstern booking</th>
                <td>{{ data.item.booking_url }}</td>
              </tr>
              <tr v-if="data.item.booking_email">
                <th>E-postadresse</th>
                <td>{{ data.item.booking_email }}</td>
              </tr>
              <tr v-if="data.item.booking_address">
                <th>Adresse</th>
                <td>{{ data.item.booking_address }}</td>
              </tr>
              <tr v-if="data.item.booking_info">
                <th>Øvrig info</th>
                <td>
                  <div v-html="data.item.booking_info"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </b-table>
    </div>
    <div class="section" v-if="inactiveProducts">
      <h4>Inaktive produkter</h4>
      <b-table fixed :items="inactiveProducts" :fields="fields">
        <template #cell(name)="data">
          <a
            target="_blank"
            :href="`${urlPrefix}opplevelser/${data.item.product.slug}`"
            >{{ data.item.product.name }} ({{ data.item.place.name }})</a
          >
        </template>
        <template #cell(show_details)="data">
          <b-button
            size="sm"
            @click="data.toggleDetails"
            class="mr-2"
            variant="outline-secondary"
          >
            {{ data.detailsShowing ? "Skjul" : "Vise" }} bookingopplysninger
          </b-button>
        </template>
        <template slot="row-details" slot-scope="data">
          <table class="table mt-3">
            <tbody>
              <tr v-if="data.item.price">
                <th>Pris</th>
                <td>
                  {{
                    parseInt(data.item.price.current.amount / 100).toFixed(2)
                  }}
                  kr
                </td>
              </tr>
              <tr v-if="data.item.booking_phone">
                <th>Telefonnummer</th>
                <td>{{ data.item.booking_phone }}</td>
              </tr>
              <tr v-if="data.item.booking_phone_time">
                <th>Telefontid</th>
                <td>{{ data.item.booking_phone_time }}</td>
              </tr>
              <tr v-if="data.item.booking_website_url">
                <th>Hjemmeside</th>
                <td>{{ data.item.booking_website_url }}</td>
              </tr>
              <tr v-if="data.item.booking_url">
                <th>Ekstern booking</th>
                <td>{{ data.item.booking_url }}</td>
              </tr>
              <tr v-if="data.item.booking_email">
                <th>E-postadresse</th>
                <td>{{ data.item.booking_email }}</td>
              </tr>
              <tr v-if="data.item.booking_address">
                <th>Adresse</th>
                <td>{{ data.item.booking_address }}</td>
              </tr>
              <tr v-if="data.item.booking_info">
                <th>Øvrig info</th>
                <td>
                  <div v-html="data.item.booking_info"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  mounted() {
    this.getProducts();
  },
  data() {
    return {
      urlPrefix: process.env.VUE_APP_APP_URL,
      fields: [
        {
          key: "name",
          label: "Navn",
        },
        {
          key: "show_details",
          label: "Bookingopplysninger",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/getUser",
      activeProducts: "products/activeProducts",
      inactiveProducts: "products/inactiveProducts",
      bookableProducts: "products/bookableProducts",
    }),
  },
  methods: {
    ...mapActions({
      getProducts: "products/getProducts",
    }),
  },
};
</script>

<style scoped>
th {
  width: 50%;
}
</style>
